var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"external"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticStyle:{"width":"100%","height":"100%"},style:({height: (_vm.screenHeight-160)+'px'}),attrs:{"src":_vm.url,"frameborder":"0"}})
}]

export { render, staticRenderFns }